import * as React from "react"
import { cn } from "@/lib/utils"

export interface AvatarProps extends React.ImgHTMLAttributes<HTMLImageElement> { fallback?: string }

export function Avatar({ className, fallback, alt, ...props }: AvatarProps) {
  const [err,setErr]=React.useState(false)
  return (
    <div className={cn("inline-flex h-9 w-9 items-center justify-center overflow-hidden rounded-full border border-border bg-muted", className)}>
      {!err && props.src ? (
        <img onError={()=>setErr(true)} alt={alt} className="h-full w-full object-cover" {...props} />
      ) : (
        <span className="text-xs text-foreground/70">{fallback ?? (alt?.[0]?.toUpperCase() ?? '?')}</span>
      )}
    </div>
  )
}
